import { createFileRoute } from '@tanstack/react-router';

import { PlatformRedFlagListScreen } from '@/features/red-flags/components/platform/RedFlagListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/red-flags/')({
  beforeLoad: () => {
    requirePermission('red_flag:read');
  },
  component: PlatformRedFlagListScreen,
  staticData: { crumb: 'Red flags' },
});
